import React from 'react';
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import DeleteSectionButton from './../DeleteSectionButton';
import LastUpdatedAt from './../LastUpdatedAt';
import {
  TextInput,
  RichTextInput,
  HookFormDirtyCheck,
} from "../../react-hook-form-inputs";

const UseOfFundSchema = Yup.object().shape({
  content: Yup.object()
    .test(
      'has text',
      'Article content is required',
      value => value && value.getCurrentContent().getPlainText().replace(/\s/g, '').length > 0
    ),
  title: Yup.string()
    .required('Summary is required')
    .max(150),
});

export default function UseOfFundForm({
  pitch:{use_of_funds_section={}, pitchable_id}, pitchableType, pitchableId, updatePitchMutation
}) {
  if(use_of_funds_section === null) use_of_funds_section = {};

  const defaultValues = {
    title: use_of_funds_section.title || '',
    content: RichTextInput.createState(use_of_funds_section.content),
  }
  const methods = useForm({
    resolver: yupResolver(UseOfFundSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: defaultValues
  });

  React.useEffect(() => {
    methods.setValue("title", use_of_funds_section.title || "");
    methods.setValue("content", RichTextInput.createState(use_of_funds_section.content || ""));
  }, [methods, use_of_funds_section]);

  const onSubmit = values => {
    const { title, content } = values
    updatePitchMutation.mutate({
      pitchable_type: pitchableType,
      pitchable_id: pitchableId,
      values: {
        pitch: {
          use_of_funds_section_attributes: {
            title,
            content: RichTextInput.contentForSave(content),
          }
        }
      }
    })
  }

  return(
    <div id="useOfFundForm">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-1">
          <div className="col-xs-12 row">
            <div className="col-lg-7">
              <label className="mb-1">Article content</label>
              <RichTextInput name="content" hideExternalPlugins={false} containerStyle={{ height: "400px"}}/>
            </div>
            <div className="col-lg-5">
              <label className="mb-1">Brief summary</label>
              <TextInput
                name="title"
                placeholder="Brief summary (max 150 chars)"
              />
            </div>
          </div>
          <div className="form-group mt-3">
            <button type="submit"
              className="mx-auto btn btn-outline-dark rounded-0"
              disabled={methods.isSubmitting}
            >
              Save Section
            </button>
            <DeleteSectionButton pitchableType={pitchableType} pitchableId={pitchableId} sectionId={use_of_funds_section.id} sectionType="use_of_funds"/>
            <LastUpdatedAt updatedAt={ use_of_funds_section.updated_at }/>
            <HookFormDirtyCheck />
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
